import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { AnalyticsModule } from 'app/analytics/analytics.module';
import { FilesModule } from 'app/files/files.module';
import { OrderComponent } from './order/order.component';
import { OrderListService } from './orders.service';
import { OrderService } from './order.service';
import { OrderSettingsComponent } from './settings/settings.component';
import { OrderSettingsDcComponent } from './settings-dc/settings-dc.component';
import { OrdersComponent } from './orders.component';
import { UIModule } from 'app/ui/ui.module';
import { WizardCreateComponent } from './wizard/create/create.component';
import { WizardService } from './wizard/wizard.service';
import { WizardUploadComponent } from './wizard/upload/upload.component';
import { WizardUseExamplesComponent } from './wizard/use-examples/use-examples.component';

import { MoneyPipe } from './order/money.pipe';
import { SamplePreviewComponent } from './wizard/use-examples/sample-preview/sample-preview.component';
import { FeedbackModule } from '../feedback/feedback.module';
import { OrderErrorsComponent } from './order/orderErrors/order-errors.component';
import { OrderErrorsModalDirective } from './order/orderErrors/order-errors-modal.directive';
import { PaginationModule } from 'app/pagination/pagination.module';
import { SamplesSliderComponent } from './wizard/use-examples/samples-slider/samples-slider.component';
import { OrderDetailsComponent } from './order/orderDetails/order-details.component';

@NgModule({
  imports: [
    AnalyticsModule,
    CommonModule,
    FilesModule,
    FormsModule,
    ReactiveFormsModule,
    FeedbackModule,
    PaginationModule,
    UIModule
  ],
  declarations: [
    OrderDetailsComponent,
    MoneyPipe,
    OrderComponent,
    OrderErrorsComponent,
    OrderErrorsModalDirective,
    OrdersComponent,
    OrderSettingsComponent,
    OrderSettingsDcComponent,
    SamplePreviewComponent,
    WizardCreateComponent,
    WizardUploadComponent,
    WizardUseExamplesComponent,
    SamplesSliderComponent
  ],
  entryComponents: [
    OrderDetailsComponent,
    OrderErrorsComponent,
    WizardCreateComponent,
    WizardUploadComponent,
    WizardUseExamplesComponent
  ],
  exports: [
    OrdersComponent,
    OrderDetailsComponent,
    OrderSettingsComponent,
    OrderSettingsDcComponent,
  ],
  providers: [
    OrderListService,
    OrderService,
    WizardService
  ]
})
export class OrdersModule {
}
